// Pure helpers extracted from Timesheet.jsx (Iter-113 refactor).
// Keep in sync with backend MISSION_COLORS.

export function monthMatrix(year, month) {
  const firstDay = new Date(year, month - 1, 1);
  const lastDay = new Date(year, month, 0);
  // Monday = 0
  const jsDay = firstDay.getDay();
  const offset = (jsDay + 6) % 7;
  const cells = [];
  for (let i = 0; i < offset; i++) cells.push(null);
  for (let d = 1; d <= lastDay.getDate(); d++) cells.push(d);
  while (cells.length % 7 !== 0) cells.push(null);
  return cells;
}

// ISO 8601 week number + ISO year. Returns { year, week } where year is the ISO
// year (which may differ from the calendar year for early-Jan / late-Dec dates).
export function isoWeekOf(date) {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const dayNum = d.getUTCDay() || 7; // Sun=7
  d.setUTCDate(d.getUTCDate() + 4 - dayNum); // shift to Thursday of this week
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  const week = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
  return { year: d.getUTCFullYear(), week };
}

// Returns the Monday of the calendar row given the row's first non-null day in the month.
export function rowMondayDate(year, month, rowCells) {
  for (let i = 0; i < rowCells.length; i++) {
    if (rowCells[i] != null) {
      const d = rowCells[i];
      const dt = new Date(year, month - 1, d);
      const dow = (dt.getDay() + 6) % 7; // Mon=0..Sun=6
      dt.setDate(dt.getDate() - dow);
      return dt;
    }
  }
  return null;
}

// Iter-87: deterministic BAIM-palette color per mission_id (matches backend MISSION_COLORS).
export const BAIM_MISSION_PALETTE = [
  "#1E3A5F", "#2E6E6B", "#B8862B", "#5B7A5A",
  "#3F4A7A", "#A0526B", "#9C6820", "#4A5568",
];

export function getMissionColor(id) {
  if (!id) return "#4A5568";
  let h = 5381;
  for (let i = 0; i < id.length; i++) h = ((h * 33) ^ id.charCodeAt(i)) >>> 0;
  return BAIM_MISSION_PALETTE[h % BAIM_MISSION_PALETTE.length];
}

// Iter-104: single source of truth for mission color across the timesheet.
export function colorOf(m) {
  return (m && m.color) || getMissionColor(m?.mission_id);
}
